import {
  number, oneOfType, shape, string,
} from 'prop-types'

// Shape of a community image as useGalleryImages normalizes it from the gallery endpoint.
export const imageShape = {
  id: oneOfType([number, string]).isRequired,
  assetId: number,
  slug: string,
  title: string.isRequired,
  src: string.isRequired,
  aspectRatio: number.isRequired,
  prompt: string,
  createdAt: string,
  user: shape({ username: string, avatar_url: string }),
  settings: shape({
    reference: string,
    baseModel: string,
    aspectRatio: string,
    style: string,
    resolution: string,
    seed: number,
  }),
}
